import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
type StickyCTAProps = {
  time: {
    hours: number;
    minutes: number;
    seconds: number;
  };
};
const pad = (n: number) => String(n).padStart(2, "0");
const WATCHED = ["inicio", "precios", "oferta-final"];
export function StickyCTA({
  time
}: StickyCTAProps) {
  const [visibleIds, setVisibleIds] = useState<string[]>(["inicio"]);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      setVisibleIds(prev => {
        const next = new Set(prev);
        entries.forEach(e => e.isIntersecting ? next.add(e.target.id) : next.delete(e.target.id));
        return Array.from(next);
      });
    });
    WATCHED.forEach(id => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);
  const show = visibleIds.length === 0;
  return <AnimatePresence data-id="element-295" data-mp="2dz47trai6cen">
      {show && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-paper/10 bg-forestDeep px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 text-paper md:hidden" data-id="element-296" data-mp="3fbrfrltwxrpl">
          <div className="flex items-center justify-between gap-3" data-id="element-297" data-mp="3k99s7m752p2c">
            <div className="min-w-0" data-id="element-298" data-mp="1w3i3v5lz50o">
              <p className="flex items-baseline gap-1.5" data-id="element-299" data-mp="1v1wwxuvp258">
                <span className="text-xs text-paper/60" data-id="element-300" data-mp="3u1ffiimg4ib7">Desde</span>
                <span className="font-display text-xl text-goldSoft" data-id="element-301" data-mp="bv13ip7qmifg">$14.999</span>
                <span className="text-xs text-paper/50 line-through" data-id="element-302" data-mp="bsyea7eestbs">$29.990</span>
              </p>
              <p className="text-[11px] tabular-nums text-paper/70" data-id="element-303" data-mp="6tvdiz5gp99m">
                Termina en {pad(time.hours)}:{pad(time.minutes)}:{pad(time.seconds)}
              </p>
            </div>
            <a href="#precios" className="shrink-0 rounded-full bg-gold px-5 py-3 text-sm font-semibold text-forestDeep transition-[background-color,transform] duration-150 ease-out active:scale-[0.97]" data-id="element-304" data-mp="28p5r1fwdsqbb">
              Ver ofertas
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}